module.exports = __webpack_public_path__ + "components/flag/static/square/gh-e9d41a4dae272652c47e5624ff14068b.svg";